export const EXIST_FLAG = {
  checking: -1,
  exist: 1,
  notExist: 0,
};
